import { PhagesList } from "./PhagesList";
import { PhagesShow } from "./PhagesShow";
import { PhagesCreate } from "./PhagesCreate";
import { PhagesEdit } from "./PhagesEdit";

export const phages = {
  list: PhagesList,
  show: PhagesShow,
  create: PhagesCreate,
  edit: PhagesEdit,
};
